import Breadcrumbs from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  CLIENT_TYPE_CONST,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import {
  MODE_INVOICE_ACTION,
  TYPE_INVOICE_ANOTHER,
} from "constants/IssueInvoiceConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { TENANT_CODE } from "constants/TennantConstant";
import { getResourceIdXML } from "helpers/form_helper";
import { getFileNameExcel, toastWarningIsAllStore } from "helpers/utils";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import CompareInvoiceModal from "pages/IssueInvoice/modal/CompareInvoiceModal";
import PDFViewModal from "pages/IssueInvoice/modal/PDFViewModal";
import {
  COMMON_CONDITION_VISIBLE,
  KHMSHDON,
  checkDateWhenRelease,
  getRowInvoiceReplaceAdjustInfo,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "pages/IssueInvoice/utils";
import DetailData from "pages/WarehouseAgency/modal/DetailData";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import {
  downloadXmlIssueInvoice,
  exportInvoiceWarehousesAgency,
  getCloneEnvoice,
  getDataLink,
  getInvoiceMinDate,
  listInvoiceSymbol,
  listIssueInvoice,
  releaseIssueInvoice,
  resetAdjustIssueInvoice,
  resetCancelIssueInvoice,
  resetDeleteIssueInvoice,
  resetDownloadXmlIssueInvoice,
  resetExportInvoiceWarehousesAgency,
  resetGetInvoiceMinDate,
  resetListInvoiceSymbol,
  resetListIssueInvoice,
  resetReleaseIssueInvoice,
  resetReplaceIssueInvoice,
} from "store/actions";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import {
  ADJUST_ISSUE_INVOICE_FAIL,
  ADJUST_ISSUE_INVOICE_SUCCESS,
  CANCEL_ISSUE_INVOICE_FAIL,
  CANCEL_ISSUE_INVOICE_SUCCESS,
  DELETE_ISSUE_INVOICE_FAIL,
  DELETE_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS,
  GET_INVOICE_MIN_DATE_FAIL,
  GET_INVOICE_MIN_DATE_SUCCESS,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import SignHSMModal from "../modal/SignHSMModal";
import TypeSignDigitalModal from "../modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "../modal/VerifyPinUSBModal";

const ListAgentError = props => {
  const { filterList, pageView, title, titleManger, khhdonDefault, children } =
    props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["warehouseAgency"]);
  const { addToast } = useToasts();
  const history = useHistory();
  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingList,
    errorList,
    list: issueInvoiceList,
    fileDownload,
    fileDownloadName,
    type,
    deleteInvoice,
    cancelInvoice,
    successClone,
    exportInvoiceWarehousesAgencyData,
    adjustIssueInvoice: adjustIssueInvoiceData,
    replaceIssueInvoice: replaceIssueInvoiceData,
    invoiceMaxMinDate,
  } = issueInvoice;

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const { errorList: errorInvoiceSymbolList, list: invoiceSymbolList } =
    invoiceSymbol;

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  // modalCheckRelease
  const childRef = useRef();
  const [rowRelease, setRowRelease] = useState(null);
  const [titleBodyCheckRelease, setTitleBodyCheckRelease] = useState("");
  const [modalCheckRelease, setModalCheckRelease] = useState(false);
  const toggleCheckReleaseModal = () =>
    setModalCheckRelease(!modalCheckRelease);

  // modalDenyRelease
  const [titleBodyDenyRelease, setTitleBodyDenyRelease] = useState("");
  const [modalDenyRelease, setModalDenyRelease] = useState(false);
  const toggleDenyReleaseModal = () => setModalDenyRelease(!modalDenyRelease);

  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // Confirm Cancel modal
  const [modalConfirmCancel, setModalConfirmCancel] = useState(false);
  const toggleConfirmCancelModal = () =>
    setModalConfirmCancel(!modalConfirmCancel);
  // CompareInvoiceModal
  const [dataCompare, setDataCompare] = useState(null);
  const [modalCompareInvoice, setModalCompareInvoice] = useState(false);
  const toggleCompareInvoiceModal = () =>
    setModalCompareInvoice(!modalCompareInvoice);
  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, buStoreHeader, finalListBuCode } =
    Dashboard;

  const [isEnterprise, setIsEnterprise] = useState(false);
  useEffect(() => {
    if (tenantCodeHeader) {
      setIsEnterprise(tenantCodeHeader === TENANT_CODE.GUARDIAN);
    }
  }, [tenantCodeHeader]);

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      issueInvoiceList.params.page = 1;
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      };
      resetDataFunc();
      getListInvoiceSymbol(KHMSHDON.WAREHOUSE_AGENCY);
      //   generateBtnFooter();
    }
  }, [finalBuInfo]);

  // Get list KHHD
  const getListInvoiceSymbol = ttchung_khmshdon => {
    invoiceSymbolList.params.page = -1;
    invoiceSymbolList.params.sort = "name";
    invoiceSymbolList.params.columnFilter = {
      "filter[record_status]": "O",
      "filter[bu_code]": localStorage.getItem(BU_STORE_HEADER),
      "filter[khmhdon]": ttchung_khmshdon,
    };
    invoiceSymbolList.params.fields =
      "id,khmhdon,khhdon,bu_code,record_status,tenant_code,";
    dispatch(listInvoiceSymbol(invoiceSymbolList.params));
  };

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    issueInvoiceList.params.page = 1;
    issueInvoiceList.params.sizePerPage = 10;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };

    initColumn();
    return () => {
      dispatch(resetListIssueInvoice());
    };
  }, [dispatch, t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (issueInvoiceList) {
      setColumnsTable(initColumns);
    }

    if (issueInvoiceList.columnsVisibleHaveCode) {
      initColumn();
    }
  }, [issueInvoiceList]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  const [btnShowFooter, setBtnShowFooter] = useState({
    btnSubmitEdit: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
  });

  const [isSendSubmitEdit, setIsSendSubmitEdit] = useState(false);

  const generateBtnFooter = () => {
    setBtnShowFooter({
      btnSubmitEdit: {
        isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
        listConditionRow: [
          COMMON_CONDITION_VISIBLE.REPLACE,
          COMMON_CONDITION_VISIBLE.ADJUST,
        ],
        onClick: () => {
          setIsSendSubmitEdit(true);
        },
        toggleModal: null,
      },
    });
  };

  // Action Dispatch
  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
    }
    resetDataFunc();
  }, []);

  // Error Dispatch
  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListIssueInvoice());
    }

    if (errorInvoiceSymbolList) {
      addToast(
        errorInvoiceSymbolList.message ||
          t("message.list", {
            target: t("invoice_symbol"),
            status: t("message.error"),
          }),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListInvoiceSymbol());
    }
  }, [addToast, dispatch, errorInvoiceSymbolList, errorList, t]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }

        dispatch(resetDownloadXmlIssueInvoice());
        break;
      }
      case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
        if (!modalUSBSign) {
          console.log("jhahaha222233");
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_SUCCESS:
        addToast("Lập phiếu xuất kho thay thế thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        resetDataFunc();
        dispatch(resetReplaceIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_FAIL:
        if (
          replaceIssueInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập phiếu xuất kho thay thế thất bại, tồn tại phiếu xuất kho thay thế chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập phiếu xuất kho thay thế thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetReplaceIssueInvoice());
        break;

      case ADJUST_ISSUE_INVOICE_SUCCESS:
        addToast("Lập phiếu xuất kho điều chỉnh thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        resetDataFunc();
        dispatch(resetAdjustIssueInvoice());
        break;
      case ADJUST_ISSUE_INVOICE_FAIL:
        if (
          adjustIssueInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập phiếu xuất kho điều chỉnh thất bại, tồn tại phiếu xuất kho điều chỉnh chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập phiếu xuất kho điều chỉnh thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetAdjustIssueInvoice());
        break;

      case DELETE_ISSUE_INVOICE_SUCCESS:
        addToast("Xóa phiếu xuất kho thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        resetDataFunc();
        dispatch(resetDeleteIssueInvoice());
        break;
      case DELETE_ISSUE_INVOICE_FAIL:
        addToast("Xóa phiếu xuất kho thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDeleteIssueInvoice());
        break;

      case CANCEL_ISSUE_INVOICE_SUCCESS:
        addToast("Gửi yêu cầu hủy phiếu xuất kho thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmCancelModal();
        resetDataFunc();
        dispatch(resetCancelIssueInvoice());
        break;
      case CANCEL_ISSUE_INVOICE_FAIL:
        addToast("Gửi yêu cầu hủy phiếu xuất kho thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCancelIssueInvoice());
        break;
      case EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoiceWarehousesAgency());
        break;
      }
      case EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetExportInvoiceWarehousesAgency());
        break;
      case GET_INVOICE_MIN_DATE_SUCCESS:
        if (!detailModal) {
          checkDateWhenRelease(
            invoiceMaxMinDate.data.min,
            invoiceMaxMinDate.data.max,
            new Date(rowRelease.ttchung_nlap * 1000),
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyDenyRelease(
                `Đã có phiếu xuất kho phát hành ngày ${maxDateLabel}. Vui lòng  cập nhật ngày lập của HĐ hiện tại về ${maxDateLabel} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiên tại).`
              );
              toggleDenyReleaseModal();
            },
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyCheckRelease(
                `Đang có Phiếu xuất kho lưu tạm có ngày lập (${minDateLabel}) nhỏ hơn ngày lập của phiếu xuất kho hiện tại (${nlapLabel}), bạn có muốn tiếp tục phát hành phiếu xuất kho này hay không?`
              );
              toggleCheckReleaseModal();
            },
            () => {
              releaseInvoiceFunc(rowRelease);
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      case GET_INVOICE_MIN_DATE_FAIL:
        if (!detailModal) {
          addToast(
            "Lấy thông tin ngày lập phiếu xuất kho lưu tạm xa nhất thất bại",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      default:
        break;
    }
  }, [type]);

  const initColumn = () => {
    if (issueInvoiceList.columnsVisible) {
      for (const item of initColumns) {
        if (issueInvoiceList.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !issueInvoiceList.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    // dispatch(setListVATInvoiceHaveCodeColumn(field, value));
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    issueInvoiceList.params.sort = sortField
      ? sortOrder + sortField
      : issueInvoiceList.params.sort;
    issueInvoiceList.params.columnFilter =
      { ...columnFilter, ...filterList } || {};
    issueInvoiceList.params.page = page || 1;
    issueInvoiceList.params.sizePerPage = sizePerPage || 10;
    resetDataFunc();
  };

  const onSearchAllHandle = value => {
    issueInvoiceList.params.keywords = value;
    resetDataFunc();
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };

  const toastAddInvoice = () => {
    return addToast("Bạn chưa đăng ký sử dụng loại phiếu xuất kho này", {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const createInvoiceHanler = () => {
    if (toastWarningIsAllStore(addToast)) {
      return;
    }
    if (finalBuInfo) {
      if (finalBuInfo.ctu === 1) {
        actionCreate();
      } else {
        toastAddInvoice();
      }
    }
  };

  const actionCreate = () => {
    setDataConfirmAction(null);
    setDataDetail({});
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
        setMode(issueInvoiceModeList.CREATE_WAREHOUSE_AGENCY_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };
  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      getListInvoiceSymbol(row.ttchung_khmshdon);
      if (row.adjust_mod) {
        setDataConfirmAction({
          typeAdjust: row.adjust_mod,
        });
      } else {
        setDataConfirmAction(null);
      }
      setDataDetail({
        id: row.id,
        tthdlquan_tchdon: row.tthdlquan_tchdon,
        root: row.root,
        child: row.child,
        tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
        tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
        tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
        tthdlquan_shdclquan: row.tthdlquan_shdclquan,
        tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
      });
      setMode(issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL);
      toggleDetailModal();
    },
  };

  const checkBeforeRelease = row => {
    if (toastWarningIsAllStore(addToast)) {
      return;
    }
    setRowRelease(row);
    dispatch(
      getInvoiceMinDate(
        row?.ttchung_khmshdon,
        row?.ttchung_khhdon,
        row?.bu_code
      )
    );
  };

  const releaseInvoiceFunc = row => {
    setTransferData({
      id: row.id,
      mst: row.nban_mst,
      resource_id: getResourceIdXML(row.resource_list, "raw"),
      type: TYPE_TRANSFER.INVOICE,
      invoice_type: row.invoice_type,
    });
    toggleTypeSignModal();
  };

  const cloneEnvoice = id => {
    dispatch(getCloneEnvoice(id, TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY));
  };
  const listRowAction = [
    // Phat hanh truong hop k có cap duyet
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Phát hành phiếu",
      isShow: finalBuInfo?.need_approve === 0,
      conditionVisible: COMMON_CONDITION_VISIBLE.RELEASE,
      onClick: row => {
        checkBeforeRelease(row);
      },
    },
    // Phat hanh truong hop có cap duyet và đã duyệt (Role kế toán)
    {
      icon: <i className="bx bx-send text-success" />,
      text: "Phát hành phiếu đã duyệt",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.RELEASE_APPROVED,
      onClick: row => {
        checkBeforeRelease(row);
      },
    },
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật phiếu xuất kho",
      isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.EDIT,
      onClick: row => {
        if (row.tthdlquan_tchdon) {
          let mode = null;
          switch (row.tthdlquan_tchdon) {
            case "1":
              mode = MODE_INVOICE_ACTION.REPLACE;
              break;
            case "2":
              mode = MODE_INVOICE_ACTION.ADJUST;
              break;
            default:
              break;
          }
          setDataConfirmAction({
            modeEdit: mode,
            typeAdjust: row.adjust_mod,
          });
        } else {
          setDataConfirmAction(null);
        }
        setDataDetail({
          id: row.id,
          tthdlquan_tchdon: row.tthdlquan_tchdon,
          root: row.root,
          child: row.child,
          tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
          tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
          tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
          tthdlquan_shdclquan: row.tthdlquan_shdclquan,
          tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
        });
        setMode(issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL);
        toggleDetailModal();
      },
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      onClick: row => {
        showPdfById(row.id);
      },
    },
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download XML",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        let mltdiep = null;
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else if (row.auth_status === AUTH_STATUS_APPROVE) {
          type = "tct-response";
          switch (row.invoice_type) {
            // có mã
            case "1":
              mltdiep = "202";
              break;
            // không mã
            case "0":
              mltdiep = "204";
              break;
            default:
              break;
          }
        } else {
          type = "signed";
        }
        resource_id = getResourceIdXML(row.resource_list, type, mltdiep);
        if (resource_id) {
          dispatch(
            downloadXmlIssueInvoice(
              resource_id,
              row.ttchung_thdon,
              "blob",
              TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
            )
          );
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
  ];

  const actionReplaceOrAdjustInvoice = typeAdjust => {
    setDataConfirmAction({
      ...dataConfirmAction,
      typeAdjust,
    });
    setDataDetail({ id: dataConfirmAction.id });
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
        setMode(issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: "Xuất danh sách phiếu xuất kho",
      isLoading: exportInvoiceWarehousesAgencyData.loading,
      loadingText: "Đang xuất danh sách phiếu xuất kho",
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          ...issueInvoiceList.params.columnFilter,
          sort: issueInvoiceList.params.sort
            ? issueInvoiceList.params.sort
            : "-checker_date",
          keywords: issueInvoiceList.params.keywords,
          "filter[is_problem]": 1,
        };
        dispatch(
          exportInvoiceWarehousesAgency(
            objectExport,
            getFileNameExcel("DanhSachPhieuXuatKhoGuiBanDaiLy")
          )
        );
      },
    },
  ];

  const exportFormatData = () => {
    let objectExport = {};
    columnsTable
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        // Format data
        switch (formatData.dataField) {
          case "auth_status":
            for (const key in selectFilterAuthStatus) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterAuthStatus[key];
            }
            break;
          //   case "approve_status":
          //     for (const key in selectFilterApproveStatus) {
          //       objectExport[
          //         `columns[${formatData.dataField}][mapping][${key}]`
          //       ] = selectFilterApproveStatus[key];
          //     }
          //     break;
          case "sent":
            objectExport[`columns[${formatData.dataField}][mapping][0]`] =
              "Chưa gửi mail";
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "Đã gửi mail";
            break;
          case "ttchung_khmshdon":
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "PHIẾU XUẤT KHO GTGT";
            objectExport[`columns[${formatData.dataField}][mapping][2]`] =
              "PHIẾU XUẤT KHO BH";
            break;
          case "ttchung_shdon":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "ttchung_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "ttoan_tgtttbso":
            objectExport[`columns[${formatData.dataField}][type]`] = "currency";
            break;
          default:
            break;
        }
        // Format style
        switch (formatData.dataField) {
          case "nmua_ten":
            objectExport[
              `columns[${formatData.dataField}][contentOptions][alignment][wrapText]`
            ] = true;
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][width]`
            ] = 80;
            break;
          default:
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][autoSize]`
            ] = true;
            break;
        }
        //
        const value = formatData.text;
        objectExport[key] = value;

        return formatData;
      });
    return objectExport;
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let id = row.id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    info = getRowInvoiceReplaceAdjustInfo(
      row,
      setDataCompare,
      dispatch,
      getDataLink,
      toggleCompareInvoiceModal
    );
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
          {info}
        </div>
        {row.auto_sign === 1 && (
          <Badge
            style={{ width: "110px", whiteSpace: "initial", marginTop: "2px" }}
            className={`font-size-10 text-warning`}
            pill
          >
            Tự động phát hành
          </Badge>
        )}
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    // [AUTH_STATUS_REPLACE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REPLACE]?.text, // "Thay thế",
    // [AUTH_STATUS_EDIT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_EDIT]?.text, // "Điều chỉnh",
    [AUTH_STATUS_CANCEL_WAITING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL_WAITING]?.text, // "Hủy",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const getClientType = row => {
    let client_type = row.client_type;
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.CLIENT_TYPE[client_type]?.badgeColor}`}
            pill
          >
            {commonStatus?.CLIENT_TYPE[client_type]?.text}
          </Badge>
        </div>
      </React.Fragment>
    );
  };

  const getSelectFilterClientType = () => {
    return selectFilterClientType;
  };

  const selectFilterClientType = {
    // [CLIENT_TYPE_CONST.SALE]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE]?.text,
    // [CLIENT_TYPE_CONST.SALE_ADJ]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE_ADJ]?.text,
    // [CLIENT_TYPE_CONST.IBT_GTGT]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_GTGT]?.text,
    // [CLIENT_TYPE_CONST.GRA]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA]?.text,
    // [CLIENT_TYPE_CONST.GRA_ADJ]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA_ADJ]?.text,
    [CLIENT_TYPE_CONST.IBT]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT]?.text,
    [CLIENT_TYPE_CONST.IBT_CSM]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_CSM]?.text,
  };

  const selectFilterDone = {
    ["1"]: "Đã xử lý",
    ["0"]: "Chưa xử lý",
  };

  const initColumns = [
    // {
    //   dataField: "pban",
    //   text: t("table.version"),
    //   // sort: true,
    //   // filter: textFilter({
    //   //   placeholder: t("placeholder.enter", {
    //   //     title: t("table.message_sender"),
    //   //   }),
    //   // }),
    // },
    {
      dataField: "id",
      text: "id",
      sort: true,
      hidden: env.API_AIR_BRAKE_ENV !== "dev" || isEnterprise,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px" },
      }),
    },
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { maxWidth: "120px" },
      }),
      hidden: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
    },
    {
      dataField: "client_ref_uuid",
      text: "Số tham chiếu",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "120px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ maxWidth: "120px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    // {
    //   dataField: "ttchung_thdon",
    //   text: t("table.invoice_name"),
    //   sort: true,
    //   hidden: isEnterprise,
    //   //   filter: textFilter({
    //   //     placeholder: t("placeholder.enter"),
    //   //   }),
    // },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
        style: { maxWidth: "129px" },
      }),
    },
    {
      dataField: "status_done",
      text: "Tình trạng xử lý",
      hidden: false,
      formatter: (cellContent, row) => {
        let text = "Chưa xử lý";
        let className = "badge-soft-warning";
        if (
          row.auth_status === AUTH_STATUS_APPROVE ||
          row.auth_status === AUTH_STATUS_CANCEL
        ) {
          text = "Đã xử lý";
          className = "badge-soft-success";
        }
        return (
          <div className="d-flex gap-1">
            <Badge
              style={{ width: "110px", whiteSpace: "initial" }}
              className={`font-size-12 ${className}`}
              pill
            >
              {text}
            </Badge>
          </div>
        );
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterDone,
        style: { width: "100px" },
      }),
    },
    {
      dataField: "ttchung_khmshdon",
      text: t("table.invoice_model_number_symbol"),
      hidden: true,
    },
    {
      dataField: "ttchung_khhdon",
      text: t("table.invoice_symbol"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ttchung_shdon",
      text: "Số HĐ",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) => {
        return cellContent !== "0" && cellContent ? cellContent : "Chờ cấp số";
      },
    },
    {
      dataField: "ttchung_nlap",
      text: t("table.date_created"),
      formatter: (cellContent, row) =>
        tableFormateDate(row.ttchung_nlap, false, true),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "nmua_mst",
      text: t("form.nmua_mst"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: isEnterprise,
    },
    {
      dataField: "nmua_ten",
      text: t("form.nmua_ten"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "150px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ width: "150px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "maker.display_name",
      text: t("table.maker_id"),
      sort: true,
      hidden: isEnterprise,
    },
    // {
    //   dataField: "checker_date",
    //   text: t("table.checker_date"),
    //   hidden: isEnterprise,
    //   sort: true,
    //   formatter: (cellContent, row) => tableFormateDate(row.checker_date),
    //   //   filter: customFilter({
    //   //     type: CUSTOM_DATE_FILTER_TABLE_TYPE,
    //   //   }),
    //   //   filterRenderer: (onFilter, column) => (
    //   //     <CustomDateFilter
    //   //       onFilter={onFilter}
    //   //       column={column}
    //   //       paramFilter={issueInvoiceList.params.columnFilter}
    //   //     />
    //   //   ),
    // },
    {
      dataField: "client_type",
      text: "Nguồn",
      hidden: !isEnterprise,
      formatter: (cellContent, row) => getClientType(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterClientType(),
        style: { width: "138px" },
      }),
    },
  ];

  const resetDataFunc = () => {
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    if (issueInvoiceList.params.columnFilter["filter[status_done]"]) {
      switch (issueInvoiceList.params.columnFilter["filter[status_done]"]) {
        case "0":
          issueInvoiceList.params.columnFilter["filter[auth_status][nin]"] = [
            AUTH_STATUS_APPROVE,
            AUTH_STATUS_CANCEL,
          ];
          break;
        case "1":
          issueInvoiceList.params.columnFilter["filter[auth_status][in]"] = [
            AUTH_STATUS_APPROVE,
            AUTH_STATUS_CANCEL,
          ];
          break;
        default:
          break;
      }
      delete issueInvoiceList.params.columnFilter["filter[status_done]"];
    }
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        TYPE_INVOICE_ANOTHER.ERROR_WAREHOUSE_AGENCY_TCT
      )
    );
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Breadcrumbs
          title={t(titleManger)}
          breadcrumbItem={t(title) + ` (${issueInvoiceList.totalCount})`}
        />
        <Row>
          {/* Modal START*/}
          <Col className="col-12">
            {/* Hình thức ký modal */}
            <TypeSignDigitalModal
              t={t}
              isOpen={modalTypeSign}
              typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
              transferData={transferData}
              toggle={toggleTypeSignModal}
              toggleUSBSignModal={toggleUSBSignModal}
              toggleHSMSignModal={toggleHSMSignModal}
            />
            {/* Ký USB Modal */}
            <VerifyPinUSBModal
              t={t}
              isOpen={modalUSBSign}
              downloadXmlFunc={downloadXmlIssueInvoice}
              typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
              transferData={transferData}
              resetDataFunc={resetDataFunc}
              toggle={toggleUSBSignModal}
            />
            {/* Ký HSM Modal */}
            <SignHSMModal
              t={t}
              isOpen={modalHSMSign}
              invoice_type={transferData?.invoice_type}
              transferData={transferData}
              typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
              resetDataFunc={resetDataFunc}
              releaseFunc={releaseIssueInvoice}
              resetReleaseFunc={resetReleaseIssueInvoice}
              toggle={toggleHSMSignModal}
            />
            <CompareInvoiceModal
              showPdfById={showPdfById}
              setDataCompare={setDataCompare}
              dataCompare={dataCompare}
              isOpen={modalCompareInvoice}
              toggle={toggleCompareInvoiceModal}
            />
            {/* PDFViewModal */}
            <PDFViewModal
              isOpen={modalPdfView}
              dataViewDocument={dataViewDocument}
              toggle={togglePdfViewModal}
            ></PDFViewModal>
            {/* ErrorReleaseModal */}
            <ErrorReleaseModal
              isOpen={modalErrorRelease}
              toggle={toggleErrorReleaseModal}
              id={idRelease}
              path={"invoice-tickets"}
            />
            {/* HistoryTransferModal */}
            <HistoryTransferModal
              isOpen={modalHistoryTransfer}
              toggle={toggleHistoryTransferModal}
              id={idHistory}
              path={"invoice-tickets"}
            />
            {/* Detail Modal */}
            <DetailData
              ref={childRef}
              btnShowFooter={btnShowFooter}
              dataDetail={dataDetail}
              dataConfirmAction={dataConfirmAction}
              isOpenModal={detailModal}
              toggleModal={toggleDetailModal}
              mode={mode}
              pageView={pageView}
              showPdfById={showPdfById}
              khhdonDefault={khhdonDefault}
              typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
              invoiceSymbolList={invoiceSymbolList.items}
              isRoleStore={isRoleStore}
              isRoleAccountant={isRoleAccountant}
              setTitleBodyDenyRelease={setTitleBodyDenyRelease}
              toggleDenyReleaseModal={toggleDenyReleaseModal}
              setTitleBodyCheckRelease={setTitleBodyCheckRelease}
              toggleCheckReleaseModal={toggleCheckReleaseModal}
            />
            {/* CheckRelease modal */}
            <ConfirmModal
              isOpen={modalCheckRelease}
              titleHeader={"Xác nhận Phát hành phiếu xuất kho"}
              titleBody={titleBodyCheckRelease}
              onConfirm={note => {
                toggleCheckReleaseModal();
                if (!detailModal) {
                  // phát hành ngoài list
                  releaseInvoiceFunc(rowRelease);
                } else {
                  // phát hành trong detail
                  childRef?.current?.releaseFromDetail();
                }
              }}
              textBtnConfirm={"Xác nhận"}
              textBtnCancel={"Đóng"}
              toggle={toggleCheckReleaseModal}
            />
            {/* CheckRelease modal */}
            <ConfirmModal
              isOpen={modalDenyRelease}
              titleHeader={"Từ chối phát hành phiếu xuất kho"}
              titleBody={titleBodyDenyRelease}
              onConfirm={note => {
                toggleDenyReleaseModal();
              }}
              textBtnConfirm={"Xác nhận"}
              textBtnCancel={"Đóng"}
              toggle={toggleDenyReleaseModal}
              isShowBtnConfirm={false}
            />
          </Col>
          {/* Modal E N D*/}
          <Col className="col-12">
            <Card>
              <CardBody>
                <RemoteDataTable
                  // selectRow={selectRowCheckbox}
                  // onRowsSelect={onRowsSelect}
                  // expandRow={expandRowTable}
                  keyField="id"
                  data={issueInvoiceList.items}
                  columns={columnsTable}
                  page={issueInvoiceList.params.page}
                  sizePerPage={issueInvoiceList.params.sizePerPage}
                  totalSize={issueInvoiceList.totalCount}
                  onTableChange={handleTableChange}
                  onSearchAllHandle={onSearchAllHandle}
                  optionShowColumnHandel={optionShowColumnHandler}
                  rowEvents={rowEventsHandler}
                  listMultipleRowAction={listMultipleRowAction}
                  listRowAction={
                    isRoleStore
                      ? listRowAction.filter(
                          item =>
                            item.text !== "Phát hành phiếu" &&
                            item.text !== "Hủy"
                        )
                      : listRowAction
                  }
                  loading={loadingList}
                >
                  {children}
                </RemoteDataTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

ListAgentError.propTypes = {
  filterList: PropTypes.object.isRequired,
  pageView: PropTypes.string,
  title: PropTypes.string,
  titleManger: PropTypes.string,
  khhdonDefault: PropTypes.string,
  children: PropTypes.any,
};

ListAgentError.defaultProps = {
  filterList: {},
  pageView: "",
};

export default ListAgentError;
